export var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["PermissionRequest"] = 1] = "PermissionRequest";
})(NotificationType || (NotificationType = {}));
